import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";

const useStyles = makeStyles<Theme>((theme) => ({
  checkboxRoot: {
    "&.Mui-checked": {
      color: theme.palette.primary.main,
    },
  },
  dayBox: {
    width: 40,
    height: 40,
    margin: 10,
    borderRadius: 8,
    border: "1px solid #ccc",
    color: "#333",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: 500,
    cursor: "pointer",
    "&.selected": {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      border: `1px solid ${theme.palette.secondary.main}`,
    },
  },
}));

export default useStyles;
